<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Magazine-Root',
};
</script>
